// ============================================================
// components/catalogo/ProductTable.jsx — Tabla de productos
// ============================================================

import React, { useState } from 'react';

function money(value) {
  if (!value) return 'A definir';
  return '$' + Number(value).toLocaleString('es-AR');
}

function appliesToZone(product, zone) {
  return product.zones.includes('Todas') || product.zones.includes(zone);
}

function ProductTable({ productos, zona, selectedId, onSelect, onNew, onEdit, onDeactivate }) {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('Todos');
  const [showInactive, setShowInactive] = useState(false);

  const filtered = productos
    .filter(p => showInactive || p.active)
    .filter(p => typeFilter === 'Todos' || p.type === typeFilter)
    .filter(p =>
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.family.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => a.display_order - b.display_order);

  return (
    <div className="cat-panel cat-table-panel">
      {/* Header */}
      <div className="cat-panel-header">
        <div>
          <h2>Productos configurados</h2>
          <p>La IA solo puede ofrecer productos activos. Las zonas se configuran en cada producto.</p>
        </div>
        <button className="cat-btn-primary" onClick={onNew}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Nuevo producto
        </button>
      </div>

      {/* Toolbar */}
      <div className="cat-toolbar">
        <div className="cat-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input
            placeholder="Buscar plan, combo o familia"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="cat-filter-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
          <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
            <option>Todos</option>
            <option>Combo</option>
            <option>Internet</option>
            <option>TV</option>
            <option>Adicional</option>
            <option>Promocion</option>
          </select>
        </div>
        <label className="cat-toggle-label">
          <input
            type="checkbox"
            checked={showInactive}
            onChange={(e) => setShowInactive(e.target.checked)}
          />
          Mostrar inactivos
        </label>
      </div>

      {/* Tabla */}
      <table className="cat-table">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Tipo</th>
            <th>Zonas</th>
            <th>MP / Transf.</th>
            <th>Tarjeta</th>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filtered.length === 0 && (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '40px 20px', color: '#8790a7' }}>
                No hay productos para estos filtros.
              </td>
            </tr>
          )}
          {filtered.map((p) => (
            <tr
              key={p.id}
              className={selectedId === p.id ? 'selected' : ''}
              onClick={() => onSelect(p)}
            >
              <td>
                <div className="cat-product-name">
                  <b>{p.name}</b>
                  {p.featured && <span className="cat-badge gold">Más elegido</span>}
                </div>
                <span className="cat-product-family">{p.family}</span>
              </td>
              <td><span className="cat-badge">{p.type}</span></td>
              <td className="cat-td-zones">{p.zones.join(', ')}</td>
              <td>{money(p.transfer_price)}</td>
              <td>{money(p.card_price)}</td>
              <td>
                {p.active
                  ? <span className="cat-badge success">Activo</span>
                  : <span className="cat-badge muted">Inactivo</span>
                }
              </td>
              <td>
                <div className="cat-actions" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="cat-btn-icon"
                    title="Editar"
                    onClick={() => onEdit(p)}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                  {p.active && (
                    <button
                      className="cat-btn-icon danger"
                      title="Desactivar"
                      onClick={() => onDeactivate(p.id)}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="cat-table-footer">
        {filtered.length} producto{filtered.length !== 1 ? 's' : ''} configurado{filtered.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
}

export default ProductTable;
